module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('AppTooltip', {
    attrs: {
      "bottom": "bottom",
      "maxWidth": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('router-link', _vm._g(_vm._b({
          staticClass: "menu-navigator-link",
          class: {
            ui_bgcolor__white: _vm.$route.name !== "home"
          },
          attrs: {
            "to": {
              path: "/"
            }
          }
        }, 'router-link', attrs, false), on), [_c('svg', {
          attrs: {
            "width": "20",
            "height": "16",
            "viewBox": "0 0 20 16",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8 15L1 8M1 8L8 1M1 8H19",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })])])], 1)]
      }
    }])
  }, [_c('div', {
    staticClass: "ui_color__white"
  }, [_vm._v("Назад")])]), _c('h3', {
    staticClass: "menu__title"
  }, [_vm._v("Центр опережающей профессиональной подготовки")]), _c('AppTooltip', {
    attrs: {
      "bottom": "bottom",
      "maxWidth": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('router-link', _vm._g(_vm._b({
          staticClass: "menu-navigator-link d-flex align-center justify-center",
          class: {
            active: _vm.$route.meta.inpath === "profile-cabinet"
          },
          attrs: {
            "active": _vm.isActiveCabinet,
            "to": {
              path: "/profile/favorite"
            }
          }
        }, 'router-link', attrs, false), on), [_c('div', {
          staticClass: "d-flex align-center justify-center",
          staticStyle: {
            "width": "20px",
            "height": "20px"
          }
        }, [_c('svg', {
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "viewBox": "0 0 512 512"
          }
        }, [_c('g', [_c('path', {
          attrs: {
            "d": "M437,331a255,255,0,0,0-97.28-61A148,148,0,0,0,404,148C404,66.39,337.61,0,256,0S108,66.39,108,148a148,148,0,0,0,64.26,122A256.4,256.4,0,0,0,0,512H40c0-119.1,96.9-216,216-216s216,96.9,216,216h40a254.33,254.33,0,0,0-75-181M256,256A108,108,0,1,1,364,148,108.12,108.12,0,0,1,256,256"
          }
        })])])])])], 1)]
      }
    }])
  }, [_c('div', {
    staticClass: "ui_color__white"
  }, [_vm._v("Личный кабинет")])]), (_vm.isNotificationsModule) ? _c('AppTooltip', {
    attrs: {
      "bottom": "bottom",
      "maxWidth": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('router-link', _vm._g(_vm._b({
          staticClass: "menu-navigator-link d-flex align-center justify-center",
          class: {
            active: _vm.$route.meta.inpath === "profile-notifications"
          },
          attrs: {
            "to": {
              path: "/profile/notifications"
            }
          }
        }, 'router-link', attrs, false), on), [_c('div', {
          staticClass: "d-flex align-center justify-center",
          staticStyle: {
            "width": "20px",
            "height": "20px"
          }
        }, [_c('svg', {
          attrs: {
            "width": "21",
            "height": "27",
            "stroke": "#000",
            "stroke-width": "1",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('g', {
          attrs: {
            "fill": "none"
          }
        }, [_c('path', {
          attrs: {
            "d": "M7.69 22h5.6c.13.41.21.74.21 1a3 3 0 01-5.12 2.12A3 3 0 017.5 23c0-.26.07-.6.19-1h0z"
          }
        }), _c('circle', {
          attrs: {
            "cx": "10.5",
            "cy": "3.5",
            "r": "2.5"
          }
        }), _c('path', {
          attrs: {
            "d": "M10.5 6c2.76 0 4.4.76 5.3 2.18 1.3 2.05 1.22 5.2 1.2 8.65V18c.26.97.94 2.2 2.12 4h0H1.85a39.8 39.8 0002.05-3.55c.08-.7.1-1.08.1-1.41v-.22-.67h0v-.78c0-2.99.08-5.66 1.35-7.41C6.28 6.67 7.89 6 10.5 6z"
          }
        })])])])])], 1)]
      }
    }], null, false, 3717392702)
  }, [_c('div', {
    staticClass: "ui_color__white"
  }, [_vm._v("Оповещения")])]) : _vm._e(), _c('AppTooltip', {
    attrs: {
      "bottom": "bottom",
      "maxWidth": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('router-link', _vm._g(_vm._b({
          staticClass: "menu-navigator-link d-flex align-center justify-center",
          class: {
            active: _vm.$route.meta.inpath === "profile-settings"
          },
          attrs: {
            "to": {
              path: "/profile/settings"
            }
          }
        }, 'router-link', attrs, false), on), [_c('div', {
          staticClass: "d-flex align-center justify-center",
          staticStyle: {
            "width": "27px",
            "height": "27px"
          }
        }, [_c('svg', {
          staticStyle: {
            "enable-background": "new 0 0 122.88 100.53"
          },
          attrs: {
            "version": "1.1",
            "id": "Layer_1",
            "xmlns": "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "x": "0px",
            "y": "0px",
            "viewBox": "0 0 122.88 100.53",
            "xml:space": "preserve"
          }
        }, [_c('g', [_c('path', {
          attrs: {
            "d": "M56.9,50.27h9.08c1.33,0,2.55,0.54,3.42,1.42c0.88,0.88,1.42,2.09,1.42,3.42v19.14c0,1.33-0.54,2.54-1.42,3.42 c-0.88,0.88-2.09,1.42-3.42,1.42H56.9c-1.33,0-2.54-0.54-3.42-1.42c-0.88-0.88-1.42-2.09-1.42-3.42V55.12 c0-1.33,0.54-2.55,1.42-3.42C54.36,50.82,55.57,50.27,56.9,50.27L56.9,50.27z M6.97,13.96h31.5V4.94c0-1.36,0.55-2.59,1.45-3.49 C40.81,0.55,42.05,0,43.41,0h36.06c1.36,0,2.59,0.55,3.49,1.45c0.89,0.89,1.45,2.13,1.45,3.49v9.03h31.5 c1.92,0,3.66,0.78,4.93,2.05c1.26,1.26,2.05,3.01,2.05,4.93v72.62c0,1.92-0.78,3.66-2.05,4.93c-1.26,1.26-3.01,2.05-4.93,2.05H6.97 c-1.92,0-3.66-0.78-4.93-2.05C0.78,97.22,0,95.48,0,93.56V20.94c0-1.92,0.78-3.66,2.05-4.93C3.31,14.75,5.05,13.96,6.97,13.96 L6.97,13.96z M79.47,4.33H43.41c-0.17,0-0.32,0.07-0.43,0.18c-0.11,0.11-0.18,0.26-0.18,0.43v8.93h37.28V4.94 c0-0.17-0.07-0.32-0.18-0.43C79.79,4.39,79.64,4.33,79.47,4.33L79.47,4.33z M4.32,55.63c15.93,4.58,27.71,6.55,43.65,7.29v4.33 c-15.93-0.73-27.71-2.65-43.65-7.14v33.44c0,0.73,0.3,1.39,0.78,1.87c0.48,0.48,1.14,0.78,1.87,0.78h108.93 c0.73,0,1.39-0.3,1.87-0.78c0.48-0.48,0.78-1.14,0.78-1.87V60.12c-15.91,4.48-26.98,6.4-42.88,7.13v-4.33 c15.91-0.75,26.98-2.72,42.88-7.29V20.94c0-0.73-0.3-1.39-0.78-1.87c-0.48-0.48-1.14-0.78-1.87-0.78H6.97 c-0.73,0-1.39,0.3-1.87,0.78c-0.48,0.48-0.78,1.14-0.78,1.87V55.63L4.32,55.63z M65.98,54.6H56.9c-0.14,0-0.27,0.06-0.36,0.15 c-0.09,0.09-0.15,0.22-0.15,0.36v19.14c0,0.14,0.06,0.27,0.15,0.36c0.09,0.1,0.22,0.15,0.36,0.15h9.08c0.14,0,0.27-0.06,0.36-0.15 c0.09-0.09,0.15-0.22,0.15-0.36V55.12c0-0.14-0.06-0.27-0.15-0.36C66.25,54.66,66.12,54.6,65.98,54.6L65.98,54.6z"
          }
        })])])])])], 1)]
      }
    }])
  }, [_c('div', {
    staticClass: "ui_color__white"
  }, [_vm._v("Портфолио")])]), _c('AppTooltip', {
    attrs: {
      "bottom": "bottom",
      "maxWidth": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('a', _vm._g(_vm._b({
          staticClass: "menu-navigator-link",
          class: {
            ui_bgcolor__white: _vm.$route.name !== "home"
          },
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": _vm.logout
          }
        }, 'a', attrs, false), on), [_c('div', {
          staticClass: "d-flex align-center justify-center menu-navigator-link__rounded",
          staticStyle: {
            "width": "20px",
            "height": "20px"
          }
        }, [_c('svg', {
          staticStyle: {
            "position": "relative",
            "top": "75%",
            "transform": "translateY(-50%)"
          },
          attrs: {
            "viewBox": "0 0 30 30",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('g', {
          attrs: {
            "fill": "none"
          }
        }, [_c('circle', {
          attrs: {
            "cx": "16",
            "cy": "16",
            "r": "15.275",
            "stroke-width": "1.45"
          }
        }), _c('path', {
          attrs: {
            "d": "m12.56377659.24729613c.1726056-.20117513.4430727-.28923924.7010742-.22826987.2580016.06096938.4604067.26077981.5246518.51792607.064245.25714626-.02041.52864047-.2194333.70373657l-5.06310821 5.0618742h16.77787501c.187997-.0016857.3689631.0713649.503084.2030799s.2104089.3113038.21208.4992551c0 .3948779-.3201898.7149897-.715164.7149897h-16.80951944l5.06310824 5.0618742c.2725196.2800107.2725196.7260367 0 1.0060475-.1322305.1356719-.3136714.2121905-.5031464.2121905-.1894749 0-.3709159-.0765186-.5031464-.2121905l-6.32888527-6.3273427c-.27099564-.2757127-.27099564-.7176802 0-.9933928z",
            "fill": "#000",
            "transform": "matrix(-1 0 0 1 32 0)"
          }
        })])])])])])]
      }
    }])
  }, [_c('div', {
    staticClass: "ui_color__white"
  }, [_vm._v("Выход")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3b1f4e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/profilemenu/ProfileMenu.vue
// module id = fdb717eb7545713d185d
// module chunks = 89